import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import BackOnTop from './components/BackOnTop';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home/Home';
import AboutUs from './pages/AboutUs/AboutUs';
import ContactUs from './pages/CountactUS/ContactUs';
import ScrollToTop from './components/ScrollToTop';
import './App.css';
import ArizonaModels from './pages/ArizonaModels/ArizonaModels';
import FloridaModels from './pages/FloridaModels/FloridaModels';
import TexasModels from './pages/TexasModels/TexasModels';
import PortfolioStrategy from './pages/Portfolio/PortfolioStrategy';
import ProjectDetails from './pages/ProjectDetails/ProjectDetails';

import AdminLogin from './components/Admin/AdminLogin';
import AdminDashboard from './components/Admin/AdminDashboard';

import { GoogleOAuthProvider } from '@react-oauth/google';

const LayoutContent = ({ isAuthenticated, setIsAuthenticated }) => {
  const location = useLocation();
  // Check if the path starts with admin
  const isAdminPath = location.pathname.startsWith('/admin');

  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Show header only if we arent on the admin path */}
      {!isAdminPath && <Header />}
      
      <ScrollToTop />
      
      <main className="flex-grow-1" style={{ paddingTop: isAdminPath ? '0' : '105px' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/arizona-models" element={<ArizonaModels />}/>
          <Route path="/florida-models" element={<FloridaModels />}/>
          <Route path="/texas-models" element={<TexasModels />}/>
          <Route path="/portfolio-strategy" element={<PortfolioStrategy />}/>
          <Route path="/project/:slug" element={<ProjectDetails />} />
          
          {/* Admin route */}
          <Route path="/admin-portal-access" element={<AdminLogin onLogin={setIsAuthenticated} />} />
          <Route path="/admin-dashboard" 
            element={
              <ProtectedRoute isAllowed={isAuthenticated}>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </main>

      {/* Show footer only if we arent on the admin path */}
      {!isAdminPath && <Footer />}
    </div>
  );
};

// Main app component
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <GoogleOAuthProvider clientId="612578098571-nrlig79933ogfinklq4hr6rk0i24q5jt.apps.googleusercontent.com">
      <Router>
        <BackOnTop />
        <LayoutContent 
          isAuthenticated={isAuthenticated} 
          setIsAuthenticated={setIsAuthenticated} 
        />
      </Router>
    </GoogleOAuthProvider>
  );
}

const ProtectedRoute = ({ isAllowed, children }) => {
  if (!isAllowed) {
    return <Navigate to="/admin-portal-access" replace />;
  }
  return children;
};

export default App;
